var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isLgUp
    ? _c("app-stock-edit-desktop", {
        attrs: {
          "selected-row": _vm.selectedRow,
          stocks: _vm.stocks,
          "is-saving": _vm.isSaving,
        },
        on: {
          cancel: function ($event) {
            return _vm.cancel()
          },
          "edit-row": function ($event) {
            return _vm.onEditRow($event)
          },
          "add-row": function ($event) {
            return _vm.onAddRow($event)
          },
          "remove-row": function ($event) {
            return _vm.onRemove($event)
          },
          save: function ($event) {
            return _vm.save()
          },
        },
      })
    : _c("app-stock-edit-mobile", {
        attrs: {
          "is-saving": _vm.isSaving,
          "selected-row": _vm.selectedRow,
          stocks: _vm.stocks,
        },
        on: {
          cancel: function ($event) {
            return _vm.cancel()
          },
          "edit-row": function ($event) {
            return _vm.onEditRow($event)
          },
          "add-row": function ($event) {
            return _vm.onAddRow($event)
          },
          "remove-row": function ($event) {
            return _vm.onRemove($event)
          },
          save: function ($event) {
            return _vm.save()
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }